import { useNavigate } from "react-router";
import Spinner from "./Spinner";
import { Button } from "./ui/button";

const SpinnerScreen = () => {
  const navigate = useNavigate();
  return (
    // <Animation>
    <div className="fade-in w-screen h-screen flex flex-col justify-center items-center bg-white position-fixed top-0 left-0">
      <Button
        className="m-0 p-0 fixed"
        style={{ top: "2rem", left: "2rem", width: "4rem", height: "3rem" }}
        onClick={() => navigate(-1)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          fill="white"
          className="bi bi-arrow-left"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
          />
        </svg>
      </Button>
      <Spinner />
    </div>
    // </Animation>
  );
};

export default SpinnerScreen;
